import React from 'react';
import { connect } from 'react-redux';
// import { NavLink } from 'react-router-dom'
import { Button, ButtonToolbar } from 'reactstrap';
import BlogCategories from '../../../../shared/components/blog-categories/BlogCategories';
import {withTranslation} from "react-i18next";

const WizardFormConfigure = ({blog, t, nextPage}) => (
  <form className="form form--horizontal wizard__form" onSubmit={(e) => { e.preventDefault() }}>
    <div className="form__form-group">
      <h3 className="wizard__title">{t('create.wizard.configure.configure_blog_categories')}</h3>
      <div className="form__form-group">
        <p>{t('create.wizard.configure.you_can_create_as_many_categories_as_you_want')}</p>
      </div>
      <BlogCategories blog={blog} />
    </div>
    <div className="form__form-group">
      {renderContinueButton(blog.categories.length, nextPage, t('create.wizard.configure.button_continue'))}
      {/* { props.blogs.length === 1 ? renderContinueButton(props.blog.categories.length, props.nextPage) : renderFinishButton(props.blog.categories.length) } */}
    </div>
  </form>
);

// const renderFinishButton = (isOkToFinish) => {
//   return (
//     <ButtonToolbar className="form__button-toolbar wizard__toolbar">

//         {isOkToFinish
//           ? (
//             <NavLink to="/">
//               <Button color="primary" className="next">Finish</Button>
//             </NavLink>)
//           : (
//             <Button color="primary" className="next" disabled>Finish</Button>
//           )
//         }
//       </ButtonToolbar>
//   )
// }

const renderContinueButton = (isEnabled, onNext, buttonText) => {
  return (
    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
      <Button color="primary" className="next" onClick={onNext} disabled={!isEnabled}>{buttonText}</Button>
    </ButtonToolbar>
  )
}

const mapStateToProps = (state) => {
  return {
    blogs: state.blogs.blogs,
    blog: state.blogs.blog
  }
}

export default connect(mapStateToProps)(withTranslation('dashboard')(WizardFormConfigure));
